import type { ApiError } from './types';

/**
 * Narrows an SWR/openapi-fetch error to the shape every Side service returns.
 * Endpoints that declare only a 200 leave the generated error type as `undefined`,
 * so the runtime value has to be recovered by hand until they declare their
 * failure responses.
 */
export const asApiError = (error: unknown): ApiError | undefined => {
  if (error === undefined || error === null) return undefined;
  if (typeof error === 'object') return error as ApiError;

  return { error: `${error}` };
};
